import { render } from "./LoadingScreen.vue?vue&type=template&id=3bff9256&scoped=true&ts=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=ts"
export * from "./LoadingScreen.vue?vue&type=script&lang=ts"

import "./LoadingScreen.vue?vue&type=style&index=0&id=3bff9256&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bff9256"]])

export default __exports__